export default () => ({
  me: {},
  items: [],
  pagination: [],
  item: {},
  updateProfile: false
})
